import { createContext, useContext, useState } from "react";

const RiskAnalysisContext = createContext();

export const useRiskAnalysisModals = () => {
  const context = useContext(RiskAnalysisContext);
  if (!context) {
    throw new Error("useRiskAnalysisModals must be used within RiskAnalysisProvider");
  }
  return context;
};

export const RiskAnalysisProvider = ({ children }) => {
  // Array of open risk analysis modals
  const [modals, setModals] = useState([]);

  // Open a new risk analysis modal for a workflow
  const openModal = (workflow) => {
    const modalKey = `${workflow.workflow_id}-${workflow.current_stage || 1}`;

    // Check if modal already exists for this workflow/stage
    const exists = modals.find((m) => m.key === modalKey);
    if (!exists) {
      setModals((prev) => [
        ...prev,
        {
          key: modalKey,
          workflow: workflow,
          open: true,
          isMinimized: false, // Store minimize state in context
        },
      ]);
    } else {
    }
  };

  // Close a specific risk analysis modal
  const closeModal = (modalKey) => {
    setModals((prev) => prev.filter((m) => m.key !== modalKey));
  };

  // Toggle minimize state for a specific modal
  const toggleMinimize = (modalKey) => {
    setModals((prev) =>
      prev.map((m) => (m.key === modalKey ? { ...m, isMinimized: !m.isMinimized } : m))
    );
  };

  // Close all modals
  const closeAllModals = () => {
    setModals([]);
  };

  const value = {
    modals,
    openModal,
    closeModal,
    toggleMinimize,
    closeAllModals,
  };

  return <RiskAnalysisContext.Provider value={value}>{children}</RiskAnalysisContext.Provider>;
};
